import React from 'react';
import { Fieldset } from 'primereact/fieldset';
import styles from './DadosSolicitacao.module.scss';
import Item from '../item/Item';

function DadosSolicitacao({
    dataCadastro,
    descJustificativa,
    tipoSolicitacaoAtivacao,
    contaAcessoCadastro,
}) {
    return (
        <Fieldset legend="Dados da Solicitação" className={styles.fieldset}>
            <div className={`p-grid p-fluid p-col-12 ${styles.containerItems}`}>
                <Item label="Data:" value={dataCadastro} />
                <Item label="Usuário:" value={contaAcessoCadastro?.nome} />
                <Item label="Tipo:" value={tipoSolicitacaoAtivacao?.descTipoSolicitacaoAtivacao} />
                <Item
                    label="Justificativa"
                    value={descJustificativa}
                    col="12"
                    className={styles.justificativa}
                />
            </div>
        </Fieldset>
    );
}

export default DadosSolicitacao;
